// On load add class to slider to stop css loading before js
/*
** With Slick Slider Plugin : https://github.com/marvinhuebner/slick-animation
** And Slick Animation Plugin : https://github.com/marvinhuebner/slick-animation
*/

function readyFn( jQuery ) {
    // Init slick slider + animation
    $('.slider').slick({
      speed: 1500,
        autoplaySpeed: 5500,
        autoplay:false,
      lazyLoad: 'progressive',
      dots: true,
      arrows: true,
      //appendArrows: ".slider-arrows",
      vertical: true,
    }).slickAnimation();

    $('.slider').addClass('js-onload');
    $('.slick-prev').html(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"/></svg>`);
    $('.slick-next').html(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"/></svg>`);
}

$( document ).ready( readyFn );

// Testimonial Slider Two (slick)
$(document).ready(function() {
  const $sliders = $('.testimonial-slider-two');
  if (!$sliders.length || typeof $.fn.slick !== 'function') return;

  $sliders.each(function() {
    const $slider = $(this);
    const $block = $slider.closest('.TestimonialSliderTwoBlock');
    // Find buttons that have any class token ending with -prev/-next
    const findArrow = (suffix) => {
      let $found = $();
      $block.find('button').each(function() {
        const tokens = (this.className || '').split(/\s+/);
        if (tokens.some((c) => c.endsWith(suffix))) {
          $found = $(this);
          return false;
        }
      });
      return $found;
    };
    const $prev = findArrow('-prev');
    const $next = findArrow('-next');

    $slider.slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: $prev.length && $next.length,
      prevArrow: $prev.length ? $prev : undefined,
      nextArrow: $next.length ? $next : undefined,
      autoplay: true,
      autoplaySpeed: 8000,
      pauseOnHover: true,
      adaptiveHeight: false
    });
  });
});
